import React from 'react';
import moment from 'moment';
import { InView } from 'react-intersection-observer';
import { SortableElement } from 'react-sortable-hoc';
import { TableRow, TableCell, Checkbox, Link } from '@material-ui/core';
import { Launch } from '@material-ui/icons';
import { setLanguageLabel } from 'pages/labels/languageLabels';
import { CategorizeTitles } from 'components/CategorizeTitles/CategorizeTitles';
import { StatusType } from 'enums/status-type.enum';
import { ActionsRow } from 'pages/titlesCM/titlesListCM/components/ActionsRow';
import { setStatusLabel } from 'pages/labels';
import { DragHandle } from './DragHandle';

interface ISortableItemProps {
  title: ITitle;
  writers: IUser[];
  getWriterName: (writerId: string, writers: IUser[]) => string;
  handleCheckbox: (checked: boolean, title: ITitle) => void;
  checked: boolean;
  onOpenUpdateDrawer?: (id: string) => void;
}

export const SortableItem = SortableElement(
  ({
    title,
    writers,
    getWriterName,
    handleCheckbox,
    checked,
    onOpenUpdateDrawer,
  }: ISortableItemProps) => {
    const Status = () => {
      const { publishPost, status } = title;

      return setStatusLabel(
        moment(publishPost).isAfter(new Date()) &&
          status === StatusType.WaitPublish
          ? StatusType.Scheduled
          : status,
      );
    };

    return (
      <TableRow
        style={{ cursor: 'pointer' }}
        key={`title-${title.title}-${title.id}`}
      >
        <TableCell style={{ width: '2%' }}>
          <DragHandle />
        </TableCell>
        <TableCell component="th" scope="row">
          <Checkbox
            color="primary"
            checked={checked}
            onChange={(e) => handleCheckbox(e.target.checked, title)}
          />
        </TableCell>
        <TableCell component="th" scope="row">
          <InView>
            {({ inView, ref }) => (
              <div ref={ref}>
                <CategorizeTitles
                  originalTitleId={title.originalTitleId}
                  id={title.id}
                  inView={inView}
                />
              </div>
            )}
          </InView>
        </TableCell>

        <TableCell component="th" scope="row">
          <ActionsRow
            id={title.id}
            title={title.title}
            onOpenUpdateDrawer={onOpenUpdateDrawer}
          />
        </TableCell>
        <TableCell>{setLanguageLabel(title.language)}</TableCell>
        <TableCell>{title.siteDomain}</TableCell>
        <TableCell>
          <Status />
        </TableCell>
        <TableCell>{title.niche}</TableCell>
        <TableCell>{title.tag?.toUpperCase()}</TableCell>
        <TableCell>{moment(title.createdAt).format('YYYY-MM-DD')}</TableCell>
        <TableCell>{getWriterName(title.writerId, writers)}</TableCell>
        <TableCell>{title.accountManager?.name}</TableCell>
        <TableCell>
          {title.postUrl ? (
            <Link target="_blank" rel="noreferrer" href={title.postUrl}>
              <Launch style={{ verticalAlign: 'middle' }} />
              Access Link
            </Link>
          ) : (
            <>URL Not Available</>
          )}
        </TableCell>
        <TableCell>
          {moment(title.publishPost).utc().format('YYYY-MM-DD')}
        </TableCell>
        <TableCell>
          {moment(title.deadline).utc().format('YYYY-MM-DD')}
        </TableCell>
      </TableRow>
    );
  },
);
